import Cesium from 'cesium';

const adjustLevel = (level) => Math.max(level - 1, 0);

// the only reason this subclasses from Cesium.GeographicTilingScheme
// is that Cesium performs some instanceof checks that will fail without it.
// The checks cause Cesium's rendering to break because it things the
// projection is not geographic when it really is and it looks like their
// reprojection of geographic -> geographic probably has some math bugs.
// Ideally this "extends" could be removed as we are reimplementing the
// entire api and forwarding all calls to the impl.
class MyGeographicTilingScheme extends Cesium.GeographicTilingScheme {
  constructor(options) {
    super();
    this.impl = new Cesium.GeographicTilingScheme(options);
  }

  get ellipsoid() {
    return this.impl.ellipsoid;
  }

  get projection() {
    return this.impl.projection;
  }

  get rectangle() {
    return this.impl.rectangle;
  }

  rectangleToNativeRectangle(rectangle, result) {
    return this.impl.rectangleToNativeRectangle(rectangle, result);
  }

  getNumberOfXTilesAtLevel(level) {
    return this.impl.getNumberOfXTilesAtLevel(adjustLevel(level));
  }

  getNumberOfYTilesAtLevel(level) {
    return this.impl.getNumberOfYTilesAtLevel(adjustLevel(level));
  }

  positionToTileXY(position, level, result) {
    return this.impl.positionToTileXY(position, adjustLevel(level), result);
  }

  tileXYToNativeRectangle(x, y, level, result) {
    return this.impl.tileXYToNativeRectangle(x, y, adjustLevel(level), result);
  }

  tileXYToRectangle(x, y, level, result) {
    return this.impl.tileXYToRectangle(x, y, adjustLevel(level), result);
  }
}


function createTiledImageLayer(name, {
  minimumLevel = 1,
  maximumLevel = 3,
  tileSize = 256,
  hasAlphaChannel = false,
} = {}) {
  const provider = new Cesium.UrlTemplateImageryProvider({
    url: `${process.env.PUBLIC_URL}/tiles/${name}/{z}/{x}/{reverseY}.jpg`,
    tilingScheme: new MyGeographicTilingScheme(),
    minimumLevel,
    maximumLevel,
    tileWidth: tileSize,
    tileHeight: tileSize,
    enablePickFeatures: false,
    hasAlphaChannel,
  });
  return new Cesium.ImageryLayer(provider, {
    brightness: 0.7,
  });
}

export default createTiledImageLayer;



// WEBPACK FOOTER //
// ./src/core/createTiledImageLayer.js